import { faPaperPlane, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Color } from '@/constants/color';
import Button from '@/ui/components/Button';
import Tooltip from '@/ui/components/Tooltip';

const BulkActionBar = ({
  count,
  disabled,
  taskPath,
  onRestore,
  onRemove,
  onPurgeTaskPath,
  onClear
}: {
  count: number;
  disabled: boolean;
  // Set only when every selected row is the same task, which is the one case
  // where purging by task path is an unambiguous extension of the selection.
  taskPath: string | null;
  onRestore: () => void;
  onRemove: () => void;
  onPurgeTaskPath: () => void;
  onClear: () => void;
}) => (
  <div className="flex items-center gap-2 flex-wrap rounded bg-blue-50 border border-blue-200 px-3 py-2 mb-3">
    <span className="text-sm font-medium">{count} selected</span>
    <Tooltip tooltipContent="Re-publishes each entry onto its own queue — a worker will run them again.">
      <Button color={Color.BLUE} disabled={disabled} onClick={onRestore}>
        <FontAwesomeIcon icon={faPaperPlane} className="mr-1" />
        Restore {count}
      </Button>
    </Tooltip>
    <Tooltip tooltipContent="Discards these entries without re-publishing — they will not run again.">
      <Button color={Color.RED} disabled={disabled} onClick={onRemove}>
        <FontAwesomeIcon icon={faTrash} className="mr-1" />
        Remove {count}
      </Button>
    </Tooltip>
    {taskPath && (
      <Tooltip
        tooltipContent={`Removes EVERY unacked entry for ${taskPath}, including rows not shown here.`}>
        <Button color={Color.RED} disabled={disabled} onClick={onPurgeTaskPath}>
          Purge all {taskPath}
        </Button>
      </Tooltip>
    )}
    <button type="button" className="text-xs text-gray-500 underline" onClick={onClear}>
      clear selection
    </button>
  </div>
);

export default BulkActionBar;
